import { SButton, SInputLabel, STitleContainer, STitleH3 } from './common/BCommonComponents';
import React, { useContext, useEffect, useState } from 'react';
import { FormControl, Grid, MenuItem, Select } from '@material-ui/core';
import AuthContext from './auth/AuthContext';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { AslDTO, CanaleAccessoEnum, ExportFilterDTO, PuntoServizioDTO, TipoPrestazione, UserRole } from './common/Dtos';
import { dateToIsoMantainTime, utcToLocalDate } from './common/DateUtils';
import { toast } from 'react-toastify';
import { FaFileDownload } from 'react-icons/all';
import DownloadUtils from './common/DownloadUtils';
import LuxonUtils from '@date-io/luxon';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { DateTime } from 'luxon';

export function Export() {
	const auth = useContext(AuthContext);
	const useStyles = makeStyles((theme: Theme) =>
		createStyles({
			formControl: {
				// margin: theme.spacing(1),
				width: '100%',
			},
			selectEmpty: {
				width: '100%',
				margin: '0',
			},
		}),
	);

	const classes = useStyles();
	const [aslList, setAslList] = useState<AslDTO[]>([]);
	const [puntiServizioList, setPuntiServizioList] = useState<PuntoServizioDTO[]>([]);
	const [maxDate, setMaxDate] = useState<string>('2070-12-31T23:59:59');
	const [minDate, setMinDate] = useState<string>('1970-01-01T00:00:00');
	const [errorDataInizio, setErrorDataInizio] = useState<boolean>(false);
	const [errorDataFine, setErrorDataFine] = useState<boolean>(false);
	const [errorRange, setErrorRange] = useState<boolean>(false);
	const [errorDataMsg, setErrorDataMsg] = useState<string>('');
	const [filter, setFilter] = useState<ExportFilterDTO>({
		type: 'ALL',
		tipoFrontoffice: 'ALL',
		puntoServizioId: 'ALL',
		asl: 'ALL',
		dataInizio: '',
		dataFine: '',
	})


	useEffect(() => {
		getAllPuntiServizio();
		getAsl();
	}, []);

	const getAllPuntiServizio = (asl?: string) => {
		if (asl) {
			auth.state.axiosInstance?.get('/api/puntoServizio/punti_servizio_of_asl/' + asl)
				.then(res => {
					setPuntiServizioList(res.data)
				})
				.catch(error => {
					toast.error('🛑 Errore durante il recupero dei Punti di Servizio!');
					console.log(error);
				});
		} else {
			if (auth.state.roles && (auth.state.roles.indexOf(UserRole.REPORT) >= 0)) {
				auth.state.axiosInstance?.get('/api/puntoServizio/punto_servizio_by_cooperativa?login=' + false)
					.then(res => {
						setPuntiServizioList(res.data)
					})
					.catch(error => {
						toast.error('🛑 Errore durante il recupero dei Punti di Servizio!');
						console.log(error);
					});
			} else {
				auth.state.axiosInstance?.get('/api/puntoServizio/punto_servizio_by_cooperativa/' + auth.state.cooperativa + '?login=' + false)
					.then(res => {
						setPuntiServizioList(res.data)
					})
					.catch(error => {
						toast.error('🛑 Errore durante il recupero dei Punti di Servizio!');
						console.log(error);
					});
			}
		}
	}

	const getAsl = () => {
		auth.state.axiosInstance?.get('/api/puntoServizio/asl/get_all')
			.then(res => {
				setAslList(res.data);
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero della lista delle Asl!');
				console.log(error);
			})
	}

	const handleAslChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newFilter: ExportFilterDTO = {
			...filter,
			asl: event.target.value as string
		}

		setFilter(newFilter);

		if (event.target.value === 'ALL') {
			getAllPuntiServizio();
		} else {
			getAllPuntiServizio(event.target.value as string);
		}
	}

	const handlePuntoServizioChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newFilter: ExportFilterDTO = {
			...filter,
			puntoServizioId: event.target.value as string
		}

		setFilter(newFilter);
	}

	const handleTypeChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newFilter: ExportFilterDTO = {
			...filter,
			type: event.target.value as string,
			tipoFrontoffice: event.target.value !== TipoPrestazione.FRONTOFFICE ? 'ALL' : filter.tipoFrontoffice
		}

		setFilter(newFilter);
	}

	const handleTipoFrontofficeChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newFilter: ExportFilterDTO = {
			...filter,
			tipoFrontoffice: event.target.value as string
		}

		setFilter(newFilter);
	}

	const handleDataInizioChange = (date: MaterialUiPickersDate, value?: string | null) => {
		let newFilter: ExportFilterDTO = {
			...filter,
			dataInizio: date ? date?.toString() : ''
		}
		setFilter(newFilter);
		if (auth.state.roles && (auth.state.roles.indexOf(UserRole.ADMIN) < 0)) {
			let dateTime = DateTime.fromJSDate(new Date(newFilter.dataInizio)).toUTC();
			dateTime = dateTime.plus({days: 31});
			setMaxDate(dateTime.toISODate());
		}
	};

	const handleDataFineChange = (date: MaterialUiPickersDate, value?: string | null) => {
		const newFilter: ExportFilterDTO = {
			...filter,
			dataFine: date ? date?.toString() : ''
		}
		setFilter(newFilter);

		if (auth.state.roles && (auth.state.roles.indexOf(UserRole.ADMIN) < 0)) {
			let dateTime = DateTime.fromJSDate(new Date(newFilter.dataFine)).toUTC();
			dateTime = dateTime.plus({days: -31});
			setMinDate(dateTime.toISODate());
		}
	};

	const handleAzzeraFiltri = () => {
		setFilter({
			type: 'ALL',
			tipoFrontoffice: 'ALL',
			puntoServizioId: 'ALL',
			asl: 'ALL',
			dataInizio: '',
			dataFine: '',
		});
		getAllPuntiServizio();
		setMinDate('1970-01-01T00:00:00');
		setMaxDate('2070-12-31T23:59:59');
		setErrorDataInizio(false);
		setErrorDataFine(false);
		setErrorRange(false);
		setErrorDataMsg('');
	}

	const handleExportData = () => {
		if (!checkBeforeExport()) {
			return;
		}
		const newFilter: ExportFilterDTO = {
			type: filter.type === 'ALL' ? '' : filter.type,
			tipoFrontoffice: filter.tipoFrontoffice === 'ALL' ? '' : filter.tipoFrontoffice,
			asl: filter.asl === 'ALL' ? '' : filter.asl,
			puntoServizioId: filter.puntoServizioId === 'ALL' ? '' : filter.puntoServizioId,
			dataInizio: filter.dataInizio !== '' ? dateToIsoMantainTime(filter.dataInizio) : '',
			dataFine: filter.dataFine !== '' ? dateToIsoMantainTime(filter.dataFine) : ''
		}

		auth.state.axiosInstance?.post('/api/report/export',
			newFilter,
			{
				responseType: 'blob' as 'json',
				headers: {
					Accept: 'application/octet-stream'
				}
			})
			.then(res => {

				DownloadUtils.saveFile(res.data, "Export_Prestazioni", "xlsx", true);
			})
			.catch(error => {
				if (406 === error.response.status) {
					toast.error('🛑 Impossibile effettuare un export con range di date maggiore di 31 giorni.');
				} else {
					toast.error('🛑 Errore durante il download');
				}
				console.log(error)
			});
	}

	const checkBeforeExport = (): boolean => {
		const inizioDateTime: DateTime = utcToLocalDate(filter.dataInizio);
		const fineDateTime: DateTime = utcToLocalDate(filter.dataFine);
		const daysDiff = fineDateTime.diff(inizioDateTime, ["days"]).toObject().days;

		console.log('filter', filter);

		if (auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) < 0) {
			if (filter.dataInizio === '' || filter.dataFine === '') {
				setErrorDataInizio(filter.dataInizio === '');
				setErrorDataFine(filter.dataFine === '');
				setErrorDataMsg('Data Obbligatoria');
				return false;
			}
		}

		if ((filter.dataInizio !== '' && !inizioDateTime.isValid) || (filter.dataFine !== '' && !fineDateTime.isValid)) {
			setErrorDataInizio(filter.dataInizio !== '' && !inizioDateTime.isValid);
			setErrorDataFine(filter.dataFine !== '' && !fineDateTime.isValid);
			setErrorDataMsg('Formato data non valido');
			return false;
		}

		if (inizioDateTime > fineDateTime) {
			setErrorDataInizio(true)
			setErrorDataFine(true);
			setErrorDataMsg('La data inizio deve essere precendente o uguale alla data fine');
			return false;
		}

		if (auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) < 0 && daysDiff != undefined && daysDiff > 31) {
			setErrorDataInizio(true);
			setErrorDataFine(true);
			setErrorDataMsg('Range massimo 31 giorni');
			return false;
		}
		setErrorDataInizio(false);
		setErrorDataFine(false);
		setErrorRange(false);
		setErrorDataMsg('');
		return true;
	}

	const getMinDate = (): Date => {
		return new Date('1970-01-01T00:00:00')
	}

	const getMaxDate = (): Date => {
		return new Date('2070-12-31T23:59:59')
	}

	return (
		<div>
			<STitleContainer>
				<STitleH3>Export</STitleH3>
			</STitleContainer>
			<Grid container spacing={0} className="w-100 mb-3">
				<Grid item xs={3} className="pr-2">
					<FormControl variant="outlined" className={classes.formControl}>
						<SInputLabel id="type">Tipo</SInputLabel>
						<Select
							labelId="type"
							id="typeSelect"
							className={classes.selectEmpty}
							label="Tipo"
							value={filter.type}
							onChange={handleTypeChange}
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "left"
								},
								transformOrigin: {
									vertical: "top",
									horizontal: "left"
								},
								getContentAnchorEl: null
							}}
						>
							<MenuItem value={"ALL"} key={"ALL"}>TUTTI</MenuItem>
							<MenuItem value={TipoPrestazione.FRONTOFFICE} key={TipoPrestazione.FRONTOFFICE}>{TipoPrestazione.FRONTOFFICE}</MenuItem>
							<MenuItem value={TipoPrestazione.BACKOFFICE} key={TipoPrestazione.BACKOFFICE}>{TipoPrestazione.BACKOFFICE}</MenuItem>
						</Select>
					</FormControl>
				</Grid>
				<Grid item xs={3} className="px-2">
					<FormControl variant="outlined" disabled={filter.type !== TipoPrestazione.FRONTOFFICE} className={classes.formControl}>
						<SInputLabel id="tipoFrontoffice">Canale</SInputLabel>
						<Select
							labelId="tipoFrontoffice"
							id="tipoFrontofficeSelect"
							className={classes.selectEmpty}
							label="Canale"
							value={filter.tipoFrontoffice}
							onChange={handleTipoFrontofficeChange}
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "left"
								},
								transformOrigin: {
									vertical: "top",
									horizontal: "left"
								},
								getContentAnchorEl: null
							}}
						>
							<MenuItem value={"ALL"} key={"ALL"}>TUTTI</MenuItem>
							<MenuItem value={CanaleAccessoEnum.FRONTOFFICE} key={CanaleAccessoEnum.FRONTOFFICE}>FrontOffice</MenuItem>
							<MenuItem value={CanaleAccessoEnum.MAIL} key={CanaleAccessoEnum.MAIL}>Mail</MenuItem>
							<MenuItem value={CanaleAccessoEnum.CALL_CENTER} key={CanaleAccessoEnum.CALL_CENTER}>Call Center</MenuItem>
						</Select>
					</FormControl>
				</Grid>
				<Grid item xs={3} className="px-2">
					<FormControl variant="outlined" className={classes.formControl}>
						<SInputLabel id="asl">ASL</SInputLabel>
						<Select
							labelId="asl"
							id="aslSelect"
							className={classes.selectEmpty}
							label="ASL"
							value={filter.asl}
							onChange={handleAslChange}
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "left"
								},
								transformOrigin: {
									vertical: "top",
									horizontal: "left"
								},
								getContentAnchorEl: null
							}}
						>
							<MenuItem value={"ALL"} key={"ALL"}>TUTTI</MenuItem>
							{aslList && aslList.map(asl => {
								return (
									<MenuItem value={asl.id} key={asl.id}>{asl.name}</MenuItem>
								)
							})}
						</Select>
					</FormControl>
				</Grid>
				<Grid item xs={3} className="pl-2">
					<FormControl variant="outlined" className={classes.formControl}>
						<SInputLabel id="asl">Punto di Servizio</SInputLabel>
						<Select
							labelId="punto"
							id="puntoSelect"
							className={classes.selectEmpty}
							label="Punto di Servizio"
							value={filter.puntoServizioId}
							onChange={handlePuntoServizioChange}
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "left"
								},
								transformOrigin: {
									vertical: "top",
									horizontal: "left"
								},
								getContentAnchorEl: null
							}}
						>
							{puntiServizioList && puntiServizioList.length > 0 &&
								<MenuItem value={"ALL"} key={"ALL"}>TUTTI</MenuItem>}
							{puntiServizioList && puntiServizioList.map(punto => {
								return (
									<MenuItem value={punto.id} key={punto.id}>{punto.name}</MenuItem>
								)
							})}
						</Select>
					</FormControl>
				</Grid>
			</Grid>
			<Grid container spacing={0} className="w-100 mb-3">
				<Grid item xs={3} className="pr-2">
					<MuiPickersUtilsProvider utils={LuxonUtils} locale="it-IT">
						<KeyboardDateTimePicker
							id="dataInizio"
							ampm={false}
							label="Data Inizio"
							className="w-100"
							variant="inline"
							inputVariant="outlined"
							InputLabelProps={{shrink: true}}
							onChange={handleDataInizioChange}
							format="dd/MM/yyyy HH:mm"
							okLabel={true}
							value={filter.dataInizio === '' ? null : filter.dataInizio}
							maxDate={filter.dataFine !== '' ? filter.dataFine : getMaxDate()}
							minDate={minDate}
							error={errorDataInizio}
							required={auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0 ? false : true}
						/>
					</MuiPickersUtilsProvider>
				</Grid>
				<Grid item xs={3} className="px-2">
					<MuiPickersUtilsProvider utils={LuxonUtils} locale="it-IT">
						<KeyboardDateTimePicker
							id="dataFine"
							ampm={false}
							label="Data Fine"
							className="w-100"
							variant="inline"
							inputVariant="outlined"
							InputLabelProps={{shrink: true}}
							onChange={handleDataFineChange}
							format="dd/MM/yyyy HH:mm"
							okLabel={true}
							value={filter.dataFine === '' ? null : filter.dataFine}
							minDate={filter.dataInizio !== '' ? filter.dataInizio : getMinDate()}
							maxDate={maxDate}
							error={errorDataFine}
							required={auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0 ? false : true}
						/>
					</MuiPickersUtilsProvider>
				</Grid>
				<Grid item xs={4} className="px-2 d-flex align-items-center justify-content-center"></Grid>
				<Grid item xs={2} className="pl-2 d-flex align-items-center justify-content-center">
					<SButton className="w-100 m-0" variant="secondary" onClick={handleAzzeraFiltri}>Azzera Filtri</SButton>
				</Grid>
			</Grid>
			{
				errorRange &&
				<p className="text-danger">Range massimo 31 giorni</p>
			}
			{
				errorDataMsg !== '' &&
				<p className="text-danger">{errorDataMsg}</p>
			}
			<Grid container spacing={0} className="w-100 mb-3 mt-5">
				<Grid item xs={4} className="px-2 d-flex align-items-center justify-content-center"></Grid>
				<Grid item xs={4} className="px-0 d-flex align-items-center justify-content-center">
					<SButton className="w-100 m-0" onClick={handleExportData}>
						<FaFileDownload className="mr-2"/>Genera Export
					</SButton>
				</Grid>
			</Grid>
		</div>
	)
}
